import * as React from 'react';

import type { EnterpriseBadge } from 'bundles/page-config-common/providers/enterprise/EnterpriseBadgeCollectionsProvider';
import type { MyLearning_SkillPathwayFragment as SkillPathway } from 'bundles/unified-home-common/queries/__generated__/EnterpriseGetAllSkillPathways';

type EnterpriseBadgeMetadataContextType = {
  // Not all badges are skill pathways, but all skill pathways are badges.
  isSkillPathway: boolean;
  // This will be true for all badges, we use many shared component for badges and standard s12n cards, so this is used in those contexts.
  isBadge: boolean;
  // The badge object data from enrolledBadgeCollections
  badge: EnterpriseBadge;
  // Skill pathway object data, contains information about the skills within the skill pathway.
  skillPathway?: SkillPathway;
};

// Used to hold context of badge type (skill pathway or standard badge AKA learning path) for shared components that are used for both badges and standard s12n cards.
const EnterpriseBadgeMetadataContext = React.createContext<EnterpriseBadgeMetadataContextType | undefined>(undefined);

export const useEnterpriseBadgeMetadata = () => {
  const context = React.useContext(EnterpriseBadgeMetadataContext);

  return context;
};

export default EnterpriseBadgeMetadataContext;
